import React from 'react';
import BreadCrumb from '../../../Common/BreadCrumb';
import { Container } from 'react-bootstrap';
import AlertTable from './AlertTable';
import {useTranslation} from "react-i18next";
import AlertWidget from "./AlertWidget";

const AlertList = () => {
    const { t } = useTranslation();
    document.title = t('Alerts.title')

  return (
    <React.Fragment>
        <div className="page-content">
            <Container fluid>
                <BreadCrumb
                    items={[
                        {label: t('Alerts.page_title'), path: "/alerts"}
                    ]}
                />
                <AlertWidget />
                <AlertTable/>
            </Container>    
        </div>
    </React.Fragment>
  )
}

export default AlertList
